import { select, take } from 'redux-saga/effects'

export function* waitForState(selector, ...args) {
	do {
		const state = yield select(selector, ...args)
		if (typeof state !== 'undefined') {
			return state
		}
		yield take('*')
	} while (true)
}



// WEBPACK FOOTER //
// /opt/build/repo/packages/utils/sagaUtils.js